import { create } from "zustand";
import { devtools } from "zustand/middleware";

import {
  PlanType,
  TripCategory,
  TripType,
  type TripApplication,
} from "@/shared/types/applicationTripTypes";

export type TripApplicationFormStoreActions = {
  setFormData: (data: TripApplication) => void;
  setPlanType: (value: PlanType) => void;
};

export type TripApplicationFormStoreState = {
  formData: TripApplication;
};

export type TripApplicationFormStore = TripApplicationFormStoreState &
  TripApplicationFormStoreActions;

export const initialFormDataState: TripApplication = {
  category: TripCategory.International,
  tripType: TripType.SingleTrip,
  planType: PlanType.IndividualPlan,
  startTrip: "",
  destination: [],
  endTrip: "",
};

export const useApplicationFormStore = create<TripApplicationFormStore>()(
  devtools((set) => ({
    formData: initialFormDataState,
    setFormData: (data: TripApplication) => set({ formData: data }),
    setPlanType: (value: PlanType) =>
      set(
        (state) => ({ formData: { ...state.formData, planType: value } }),
        false,
        "setPlanType",
      ),
  }))
);
